export default __webpack_public_path__ + "static/media/bodyExample.c8d6bd94.jpg";